import React from "react";
import { zipObject } from '../../utils/lodash';
import moment from 'moment';
import tobeor from 'tobeor';
import { withStyles } from '@mui/styles';
import { Table, TableRow, TableCell, TableHead, TableBody } from '@mui/material';
import ComponentWrapper from "../../common/ComponentWrapper";
import CommonStyles from "../../common/CommonStyles";

const styles = {
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
  },
  flexItem: {
    display: 'flex',
    backgroundColor: '#fff',
    flexDirection: 'column',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    flex: '0 0 auto',
    padding: '5px',
  },
  requestItemRow: {
    margin: '2px !important',
    '&:hover': {
      outline: '1px solid #222029',
    },
  },
  tableCell: {
    width: 'auto',
    border: 'none',
    display: 'table-cell',
    verticalAlign: 'middle',
    fontSize: 10,
    padding: '1px',
  },
  tblHeadCell: {
    fontSize: 9,
    fontWeight: 600,
    display: 'table-cell',
    padding: '1px 2px',
  },
  ...CommonStyles,
};

class UserLastActivity extends ComponentWrapper {
  state = {
    user_last_activity: null,
  };

  componentDidMount = () => {
    document.title = "User activity | Milkyweb";

    this.get({
      url: '/meta_query?meta_query=["user_last_activity"]',
      cb: (res) => {
        if (res) {
          const { user_last_activity } = res._meta_query;
          this.setState({ user_last_activity });
        }
      },
      disableNotify: true,
    });
  };

  getTime = (value) => {
    let diff = ~~((new Date().getTime() - value) / 1000);

    if (diff < 60) {
      diff = diff + 's';
    } else if (diff >= 60 && diff < (60 * 60)) {
      diff = '~' + ~~(diff / 60) + 'm';
    } else if (diff >= (60 * 60) && diff < (60 * 60 * 24)) {
      diff = '~' + ~~(diff / (60 * 60)) + 'h';
    } else {
      diff = '~' + ~~(diff / (60 * 60 * 24)) + 'd';
    }

    return `${diff}`;
  };

  getDomain = (url) => {
    if (!url) return;
    url = url.replace(/(https?:\/\/)?(www.)?/i, '');

    if (url.indexOf('/') !== -1) {
      return url.split('/')[0];
    }

    return url;
  };

  render() {
    const { classes } = this.props;
    const { user_last_activity } = this.state;

    const requestDataKeys = ["setup","acc","login","HTTP","req","ref","ip","country","region","city","timestamp"];
    const currentHostname = window.location.host;

    return (
      <div style={{ margin: '10px' }}>
        <div className={classes.flexContainer}>
          {user_last_activity && Object.keys(user_last_activity).map((cookieKey, index) => {
            const userData = user_last_activity[cookieKey];
            const os = userData.os;
            const browser = userData.browser;
            const userActivityArray = userData.data;
            const lastRequestData = zipObject(requestDataKeys, userActivityArray[0]);

            return (
              <div key={cookieKey} className={classes.flexItem} style={{ width: 'fit-content' }}>
                <span style={{ margin: '5px', fontSize: 9 }}>
                  <strong title='Cookie key'>{cookieKey}</strong> |
                  <strong title='Login'>{lastRequestData.login}</strong> |
                  <strong title='Browser'>{browser}</strong> |
                  <strong title='OS'>{os}</strong> |
                  <strong title='IP Address'>{lastRequestData.ip}</strong> |
                  <strong title='Location'>{`${lastRequestData.city ? lastRequestData.city : ''}
                    ${lastRequestData.region ? lastRequestData.region : ''} ${lastRequestData.country ? lastRequestData.country : ''}`}</strong>
                </span>

                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tblHeadCell}>#</TableCell>
                      <TableCell className={`${classes.tblHeadCell}`}>Setup</TableCell>
                      <TableCell className={classes.tblHeadCell}>Acc</TableCell>
                      <TableCell className={classes.tblHeadCell}>Req</TableCell>
                      <TableCell className={classes.tblHeadCell}>Ref</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {userActivityArray && userActivityArray.map((actions, index) => {
                      const actionZipObject = zipObject(requestDataKeys, actions);
                      const timestamp = this.getTime(actionZipObject.timestamp);
                      const date = moment(actionZipObject.timestamp).format('MMM DD, HH:mm');
                      const requestMethod = actionZipObject.HTTP;
                      const isGet = requestMethod === 'GET';

                      return (
                        <TableRow key={index} className={classes.requestItemRow} style={{ marginBottom: '1px', backgroundColor: isGet ? '#FFF7F2' : '#F7F2FF' }}>
                          <TableCell className={classes.tableCell}>
                            <div className={classes.flex}>
                              <div style={{ padding: '3px', fontSize: 8, marginRight: '2px', backgroundColor: isGet ? '#FFD1B2' : '#C3A0FF' }}>{requestMethod}</div>
                              <div title={date}>{timestamp}</div>
                            </div>
                          </TableCell>

                          {actions.map((action, actionIndex) => {
                            const thisKey = requestDataKeys[actionIndex];
                            if (tobeor(thisKey, ['timestamp','HTTP','country','region','city','ip','login'])) return null;

                            let isRefEqualToDomain = true;
                            if (thisKey === 'ref') {
                              const refHostname = this.getDomain(action);
                              if (refHostname && (refHostname !== currentHostname)) isRefEqualToDomain = false;
                            }
                            
                            return (
                              <TableCell className={classes.tableCell} key={actionIndex}>
                                {action ?
                                  <span
                                    title={actionZipObject.login}
                                    style={{ padding: '0 2px', color: isRefEqualToDomain ? '#4c4c4c' : '#950000' }}
                                  >
                                    {action}
                                  </span>
                                : null}
                              </TableCell>
                            )
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
};

export default withStyles(styles)(UserLastActivity);
